// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".css?ver=bd21ad19-c1bb-4ba3-a7fb-2b148db8ab39";
};